/**
 * One delegated listener for links and buttons generated from the templates.
 * Actions are declarative so adding a project never requires executable HTML.
 */
export function bindActions(app) {
  const handlers = {
    'close-menu': () => app.navigation.closeMobileMenu(),
    navigate: (element) => {
      // The navigation rail and the detail's return links lead back to the same list.
      if (element.dataset.page === 'projects') return app.navigation.backToProjects();
      app.navigation.navTo(element.dataset.page);
    },
    'back-to-projects': () => app.navigation.backToProjects(),
    'home-videos': () => app.navigation.navTo('home', {
      onComplete: () => document.getElementById('top').focus({ preventScroll: true }),
    }),
    about: () => app.navigation.goToAbout(),
    project: (element) => app.navigation.openProject(element.dataset.projectId, {
      archiveCard: element.closest('#view-projects .project-pin'),
    }),
    note: (element) => app.navigation.openNote(element.dataset.noteId),
    'contact-path': (element) => app.navigation.openContactPath(element.dataset.kind),
    inquiry: (element) => app.navigation.proposalContact(element.dataset.kind),
    copy: (element) => app.ui.copyToClipboard(element.dataset.copyValue),
    phone: (element) => app.ui.handlePhoneClick(element.dataset.phone, element),
    'copy-contact-value': () => app.ui.copyToClipboard(document.getElementById('contact-choice-value').value),
    'close-contact-choice': () => document.getElementById('contact-choice').close(),
    map: () => app.ui.openMap(),
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || !(event.target instanceof Element)) return;
    const element = event.target.closest('[data-action]');
    const handler = element && handlers[element.dataset.action];
    if (!handler) return;
    // Leave ordinary browser actions available for real deep links.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    handler(element);
    if (element.dataset.closeMenu === 'true') {
      app.navigation.closeMobileMenu();
    }
  });

  // External software-logo failures must not leave broken image indicators.
  document.addEventListener(
    'error',
    (event) => {
      const image = event.target;
      if (image instanceof HTMLImageElement && image.matches('.software-item img')) {
        image.hidden = true;
      }
    },
    true,
  );
}
